
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Procedure, ApiGateway, Firm } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class FirmEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    firm: Firm;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getFirm()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getFirm(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.firm = data;
                this.onDataChanged.next(this.firm);
                resolve(this.firm);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('firm/' + this.routeParams.id).subscribe((res: Firm ) => {
                    this.firm = res;
                    this.onDataChanged.next(this.firm);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(firm): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('firm/', firm).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(firm): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('firm/', firm).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(firm): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('firm/' + firm.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): Firm {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
